import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-section support">
            <h3 className="footer-title">Support</h3>
            <nav className="footer-nav">
              <Link to="/shipping" onClick={toTop} className="footer-link">
                Shipping Policy
              </Link>
              <Link to="/returns" onClick={toTop} className="footer-link">
                Return Policy
              </Link>
              <Link to="/privacy" onClick={toTop} className="footer-link">
                Privacy Policy
              </Link>
              <Link to="/cookies" onClick={toTop} className="footer-link">
                Cookie Policy
              </Link>
              <Link to="/faqs" onClick={toTop} className="footer-link">
                FAQs
              </Link>
              <Link to="/terms" onClick={toTop} className="footer-link">
                Terms
              </Link>
              <Link to="/about" onClick={toTop} className="footer-link">
                About Us
              </Link>
              <Link to="/contact" onClick={toTop} className="footer-link">
                Contact Us
              </Link>
            </nav>
          </div>

          <div className="footer-section newsletter">
            <h3 className="footer-title">Stay Connected</h3>
            <p className="newsletter-description">
              <a href="mailto:phase@slayfulpawsco.cloud">
                phase@slayfulpawsco.cloud
              </a>
              <br />
              390 Lofton Rd NW, Atlanta, GA 30309 US
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>Copyright © {currentYear}, slayfulpawsco</p>
          </div>

          <div
            className="payment-methods"
            aria-label="Payment options confirmed at checkout"
          />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
